import ActionTypes from '../actions/ActionTypes';

const initialState = {
  allPlans: [],
  plans: [],

  projects: [],
  allProjects: [],

  page: 1,
  commercialPlanType: null,
  showControllPlan: null,
  showControllProjects: null,
  stations: [],
  selectedStation: {},
  search: '',

};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CLEAR_SEARCH:
      return { ...state, search: ''};
    case ActionTypes.SEARCH_PROJECT:
      return { ...state, projects: state.allProjects.filter(p => p.title.toLowerCase().includes(action.payload ? action.payload.toLowerCase() : '')) };
    case ActionTypes.SEARCH_PLAN:
      return { ...state, plans: state.allPlans.filter(p => p.title.toLowerCase().includes(action.payload ? action.payload.toLowerCase() : '')) };
    case ActionTypes.UPDATE_SEARCH_PLAN:
      return { ...state, search: action.payload };
    case ActionTypes.GET_PROJECT_STATION_SUCCESS:
      return { ...state, projects: action.payload, allProjects: action.payload };
    case ActionTypes.GET_COMERCIAL_PLAN_STATION_SUCCESS:
      return { ...state, plans: action.payload, allPlans: action.payload };
    case ActionTypes.UPDATE_SELECTED_STATION:
      return { ...state, selectedStation: action.payload };
    case ActionTypes.GET_PROJECTS_SUCCESS:
      return { ...state, projects: action.payload, allProjects: action.payload };
    case ActionTypes.GET_STATIONS_SUCCESS:
      return { ...state, stations: action.payload };
    case ActionTypes.SHOW_PROJECTS:
      return { ...state, showControllProjects: !state.showControllProjects, showControllPlan: false };
    case ActionTypes.SHOW_PLANS:
      return { ...state, showControllPlan: !state.showControllPlan, showControllProjects: false };
    case ActionTypes.UPDATE_COMMERCIAL_PLAN_TYPE:
      return { ...state, commercialPlanType: action.payload, showControllPlan: false, showControllProjects: false };
    case ActionTypes.CLEAR_COMERCIAL_PLAN:
      return { ...state, plans: [] };
    case ActionTypes.GET_COMERCIAL_PLAN_PAGED_SUCCESS:
      return { ...state, plans: action.payload, allPlans: action.payload };

    case ActionTypes.GET_MORE_COMERCIAL_PLAN_SUCCESS:
      return {
        ...state,
        page: ++state.page,
        plans: [...state.plans, ...action.payload]
      };
    default:
      return state;
  }
};
